/**
 * The fixed lists New request offers — `docs/new-request.md` §4.2, §6, §7.3.
 *
 * Each is the one list the sheet draws, the server validates against and the
 * phone's bottom sheets read, so a chip the client offers is a value the
 * server takes.
 */
/** Residential or commercial — how sales coverage splits a division (§4.3). */
export const SEGMENTS = ['residential', 'commercial'];
export const SEGMENT_LABELS = {
    residential: 'Residential',
    commercial: 'Commercial',
};
/**
 * The six property types, Residential first and the default (§7.3, Board 5).
 * The value saved is the chip's word in `properties.property_type`.
 */
export const PROPERTY_TYPES = [
    { value: 'Residential', segment: 'residential' },
    { value: 'Commercial', segment: 'commercial' },
    { value: 'HOA', segment: 'commercial' },
    { value: 'Institutional', segment: 'commercial' },
    { value: 'Municipal', segment: 'commercial' },
    { value: 'Industrial', segment: 'commercial' },
];
export const PROPERTY_TYPE_VALUES = PROPERTY_TYPES.map((one) => one.value);
/**
 * Which half of the coverage grid a property falls in. `property_type` stays
 * free text elsewhere, so any value that is not *Residential*
 * (case-insensitive) counts as commercial; a property with no type at all is
 * the default, residential.
 */
export function segmentOf(propertyType) {
    const type = (propertyType ?? '').trim();
    if (!type)
        return 'residential';
    return type.toLowerCase() === 'residential' ? 'residential' : 'commercial';
}
/** The phone's kind (§6.2). Mobile is the default: it is the number that gets texts. */
export const PHONE_KINDS = ['mobile', 'office', 'home'];
export const PHONE_KIND_LABELS = {
    mobile: 'Mobile',
    office: 'Office',
    home: 'Home',
};
/** Prefers — `contacts.preferred_channel` (§6.1). */
export const PREFERS = ['sms', 'email', 'either'];
export const PREFERS_LABELS = {
    sms: 'Text',
    email: 'Email',
    either: 'Either',
};
/** The budget bands (§4.2, Board 6) and the columns each one writes. */
export const BUDGET_BANDS = [
    { key: 'not_sure', label: 'Not sure', low: null, high: null },
    { key: 'under_2500', label: 'Under $2,500', low: null, high: 2500 },
    { key: '2500_10k', label: '$2,500–10k', low: 2500, high: 10_000 },
    { key: '10k_25k', label: '$10k–25k', low: 10_000, high: 25_000 },
    { key: '25k_50k', label: '$25k–50k', low: 25_000, high: 50_000 },
    { key: '50k_plus', label: '$50k+', low: 50_000, high: null },
];
/** The band a stored pair reads as, or null for a pair no band names. */
export function budgetBandOf(low, high) {
    const l = low === null || low === undefined || low === '' ? null : Number(low);
    const h = high === null || high === undefined || high === '' ? null : Number(high);
    return BUDGET_BANDS.find((band) => band.low === l && band.high === h) ?? null;
}
/** Length and Estimate visit: 15-minute steps from 15 min to 8 h (§9.1, §14.3). */
export const LENGTH_STEPS = Array.from({ length: 32 }, (_, index) => (index + 1) * 15);
export const MIN_LENGTH = 15;
export const MAX_LENGTH = 480;
/** The company's arrival window (§4.7, Board 11). */
export const ARRIVAL_WINDOWS = [
    { minutes: 0, label: 'Exact time' },
    { minutes: 15, label: '15 min' },
    { minutes: 30, label: '30 min' },
    { minutes: 60, label: '1 hour' },
    { minutes: 120, label: '2 hours' },
];
/** Most people a schedule shows side by side (D15). */
export const SIDE_BY_SIDE_MAX = 3;
//# sourceMappingURL=types.js.map